module.exports = __webpack_public_path__ + "img/spinner.dd5dc5ec.svg";